import script from "./AuthLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./AuthLayout.vue?vue&type=script&setup=true&lang=js"

import "./AuthLayout.vue?vue&type=style&index=0&id=3643f2d4&lang=css"

const __exports__ = script;

export default __exports__